var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full sm:w-1/2 md:w-1/2 mb-base"},[_c('general-information')],1),_c('div',{staticClass:"vx-col w-full sm:w-1/2 md:w-1/2 mb-base"},[_c('prosecution-transaction')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }